function labelFormatter(fn) {
  return (params) => {
    const {
      value,
      value: [
        ,
        v = value
      ] = []
    } = params

    return fn(v, params)
  }
}

export default labelFormatter



// WEBPACK FOOTER //
// ./src/services/formatters/createLabelFormatter.js